import React from "react";
import theme from "../../../styles/theme";



const Page45 = () => {
  return (

    <div>
    <h2>"Page 45" </h2>
    </div>

  );
};

export default Page45;
